export default "__VITE_ASSET__BoZ0EtwB__"